import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import './list-orders.css'


const ListOrders = (props) => {
    const cols = [
        'N° do Pedido',
        'N° Ordem de Produção',
        'Descrição do Item',
        'Quantidade',
        'Origem',
        'Destino',
    ]

    const closeBtn = <button className="close" onClick={() => props._close()}>&times;</button>;

    return (
        <div>
            <Modal isOpen={props.visible} className='_modal-list-orders'>
                <ModalHeader close={closeBtn}></ModalHeader>
                <ModalBody>

                    <div className="container-header-list-orders">
                        {cols.map((d, i) => {
                            return (
                                <div key={i} className="header-list-orders" style={i === 0 ? { borderLeft: 'none' } : null}>
                                    {d}
                                </div>
                            )
                        })}

                    </div>

                    {props.data.map((d, i) => {

                        return (
                            <div className="container-list-orders" key={i} style={{background: i % 2 !== 0 ? '#ededed' : 'unset'}}>
                                <div className="list-orders" style={{ borderLeft: 'none' }}>
                                    {d.numPedido}
                                </div>
                                <div className="list-orders">
                                    {d.numOrdemProducao}
                                </div>
                                <div className="list-orders" >
                                    {d.descItem}
                                </div>
                                <div className="list-orders" >
                                    {d.qtde}
                                </div>
                                <div className="list-orders" >
                                    {d.origem}
                                </div>
                                <div className="list-orders">
                                    {d.destino}
                                </div>
                            </div>
                        )
                    })}

                </ModalBody>
            </Modal>
        </div>
    );
}

export default ListOrders;